         
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="id_list_tipo"
                      >
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="documento">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="name"
                      :md="12"
                      :lg="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="edad">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="id_list_genero">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="direccion"
                      :md="12"
                      :lg="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="ciudad">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="telefonos">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="email"
                      :md="12"
                      :lg="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="empresa"
                      :lg="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="cargo"
                      :lg="6">
                    </sw-inputs>
                    <sw-inputs
                      inputTabla="datos_pacientes"
                      inputCampo="id_list_eps"
                      :lg="6">
                    </sw-inputs>     
        </b-row>
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="indexData"
            nameBtn="Paciente"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  created(){
    if(this.indexData!==false)
    {
      this.updateDataForm({data: this.dataGet[this.namePath].data[this.indexData]})
    }    
  },
  async destroy()
  {
    await this.resetGlobal({state: 'indexData'})
  },
  computed: { 
  },
  methods: {
    save(event)
    {
      this.$emit('save',{save: false, ftn: 'pacienteNuevoFtn' })
    }
  }
}
</script>
<style>
</style>